<template lang="pug">
  .logout
    .page-header
      h2 Sign Out

    p You are being redirected...
</template>

<script>
export default {
  name: 'logout',
  created() {
    this.$store.commit('clearSession');
    this.$router.push('/');
  },
};
</script>
